// @vendors
import React from "react";
import { useHistory } from 'react-router-dom';
const { formatText, FormattedText} = require("core/i18n").i18n;

// @components
import WizardError from "components/commons/wizardError/wizardError";

import { CONTEXT_KEY } from 'constants/aggregator/aggregatorConsents.constants'

const AggregatorConsentsError = () => {
    const handleOnClickButton = () => {
        const history = useHistory();
        history.push("/myprofile/edit");
    };

    return (
        <WizardError
            errorMessage={formatText(`${CONTEXT_KEY}-errorTitle`)}
            customClassName="aggregator-add-entity__wizard__wizard-step-login__form__form__wizard-error"
            mainButton={{
                label: formatText(`${CONTEXT_KEY}-errorBackLabel`),
            }}
            onMainButtonClick={handleOnClickButton}
        >
            <p>
                <FormattedText value={`${CONTEXT_KEY}-errorDescription`}/>
            </p>
        </WizardError>
    );
};

export default AggregatorConsentsError;
